<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col>
            <v-card
              class="py-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary darken-2"
              ></v-progress-linear>
              <v-container v-if="!loading">
                <div v-if="!paymentStatus && statusId != 5" class="mb-6">
                  <app-headline title="สแกนเพื่อจ่ายเงิน" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row>
                    <v-col class="text-center">
                      <v-card
                        class="pa-1 mx-auto error--text"
                        min-width="310"
                        max-width="310"
                        outlined
                      >
                        <img :src="qrcode" alt="QRCode" />

                        <p class="my-1">*คำเตือน*</p>
                        "QR Code นี้สามารถ Scan เพื่อชำระค่าบริการ
                        ได้เพียงครั้งเดียว"
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="paymentStatus">
                  <v-row>
                    <v-col class="text-center success--text">
                      <h1>
                        <v-icon color="success" size="36" class="pa-2">
                          mdi-check-circle </v-icon
                        >จ่ายเงินสำเร็จ
                      </h1>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="!paymentStatus && statusId === 5">
                  <v-row>
                    <v-col class="text-center error--text">
                      <h1>
                        <v-icon color="error" size="36" class="pa-2">
                          mdi-close-circle </v-icon
                        >ยกเลิกคำขอ
                      </h1>
                    </v-col>
                  </v-row>
                </div>

                <div class="mb-6">
                  <app-headline title="รูปติดบัตร" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row>
                    <v-col>
                      <v-card
                        class="pa-0 mx-auto"
                        min-width="180"
                        max-width="480"
                        outlined
                      >
                        <v-row class="pa-1 ma-0">
                          <v-col sm="4" cols="12" class="pa-0 ma-0">
                            <div class="pa-2">
                              <v-img
                                :src="profileImg"
                                :aspect-ratio="1"
                                alt="Profile Image"
                              />
                            </div>
                          </v-col>
                          <v-col>
                            <v-row
                              v-for="(item, index) in exampleCardDetail"
                              :key="'exitem-' + index"
                            >
                              <v-col
                                align-self="start"
                                cols="4"
                                class="py-1 pl-3 ma-0"
                                :style="item.style"
                              >
                                {{ item.title }} :
                              </v-col>
                              <v-col
                                cols="8"
                                :style="item.style"
                                class="py-1 pr-3 pl-0 ma-0"
                              >
                                {{ item.value }}
                              </v-col>
                              <v-col v-if="index === 0" class="pa-1"></v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.params.type === 'admin'" justify="center">
                    <v-btn
                      class="px-12"
                      color="warning"
                      outlined
                      small
                      depressed
                      @click="onDownloadProfileImage"
                    >
                      ดาวน์โหลดรูป
                    </v-btn>
                  </v-row>
                </div>

                <div class="mb-6">
                  <app-headline title="ข้อมูลบุคคล" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row
                    v-for="(item, index) in info"
                    :key="index"
                    class="py-1"
                  >
                    <v-col
                      v-if="$vuetify.breakpoint.smAndUp"
                      sm="1"
                      class="text-center"
                    >
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-col>
                    <v-col
                      cols="6"
                      md="4"
                      lg="3"
                      xl="2"
                      class="col"
                      :class="{ 'text-right': $vuetify.breakpoint.xsOnly }"
                    >
                      <span class="font-weight-bold">{{ item.title }}</span>
                    </v-col>
                    <v-col>
                      <span>{{ item.value }}</span>
                    </v-col>
                  </v-row>
                </div>

                <div class="mb-6">
                  <app-headline title="ประเภทบัตรที่ส่งคำขอ" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row
                    v-for="(item, index) in cardDetail"
                    :key="index"
                    class="py-1"
                  >
                    <v-col
                      v-if="$vuetify.breakpoint.smAndUp"
                      sm="1"
                      class="text-center"
                    >
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-col>
                    <v-col
                      cols="6"
                      md="4"
                      lg="3"
                      xl="2"
                      class="col"
                      :class="{ 'text-right': $vuetify.breakpoint.xsOnly }"
                    >
                      <span class="font-weight-bold">{{ item.title }}</span>
                    </v-col>
                    <v-col>
                      <span>{{ item.value }}</span>
                    </v-col>
                  </v-row>
                </div>

                <div class="mb-6">
                  <app-headline title="เหตุผลในการขอทำบัตร" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row
                    v-for="(item, index) in reasonDetail"
                    :key="index"
                    class="py-1"
                  >
                    <v-col
                      v-if="$vuetify.breakpoint.smAndUp"
                      sm="1"
                      class="text-center"
                    >
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-col>
                    <v-col
                      cols="6"
                      md="4"
                      lg="3"
                      xl="2"
                      class="col"
                      :class="{ 'text-right': $vuetify.breakpoint.xsOnly }"
                    >
                      <span class="font-weight-bold">{{ item.title }}</span>
                    </v-col>
                    <v-col>
                      <span
                        @click="!!item.docName ? apiGetFile(item.docName) : ''"
                        v-html="item.value"
                      />
                    </v-col>
                  </v-row>
                </div>

                <div v-if="paymentStatus" class="mb-6">
                  <app-headline title="ใบเสร็จ" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row
                    v-for="(item, index) in receipt"
                    :key="index"
                    class="py-1"
                  >
                    <v-col
                      v-if="$vuetify.breakpoint.smAndUp"
                      sm="1"
                      class="text-center"
                    >
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-col>
                    <v-col
                      cols="6"
                      md="4"
                      lg="3"
                      xl="2"
                      class="col"
                      :class="{ 'text-right': $vuetify.breakpoint.xsOnly }"
                    >
                      <span class="font-weight-bold">{{ item.title }}</span>
                    </v-col>
                    <v-col>
                      <span
                        @click="
                          !!item.docName ? apiGetReceipt(item.docName) : ''
                        "
                        v-html="item.value"
                      />
                    </v-col>
                  </v-row>
                </div>

                <div
                  v-if="replyDetail.status && $route.params.type === 'admin'"
                  class="mb-6"
                >
                  <app-headline title="เหตุผลในการตีกลับ" class="mb-2" />
                  <v-divider></v-divider>
                  <v-row class="py-1">
                    <v-col class="px-8">
                      {{ replyDetail.reqCardReplyDetail }}</v-col
                    >
                  </v-row>
                </div>

                <div>
                  <v-row justify="end">
                    <v-col
                      v-if="
                        (statusId === 1 && $route.params.type === 'user') ||
                          (statusId === 1 && retireStatus)
                      "
                      cols="auto"
                    >
                      <v-btn
                        class="px-12 white--text"
                        color="primary"
                        depressed
                        @click="onEdit()"
                      >
                        แก้ไข
                      </v-btn>
                    </v-col>
                    <v-col
                      v-if="
                        (statusId === 1 && $route.params.type === 'user') ||
                          (statusId === 1 && retireStatus)
                      "
                      cols="auto"
                    >
                      <v-btn
                        class="px-12 white--text"
                        color="error"
                        depressed
                        @click="cancelDialog = !cancelDialog"
                      >
                        ยกเลิกคำขอ
                      </v-btn>
                    </v-col>

                    <v-col
                      v-if="statusId === 2 && $route.params.type === 'admin'"
                      cols="auto"
                    >
                      <v-btn
                        class="px-12"
                        color="success"
                        large
                        depressed
                        @click="onApprove"
                      >
                        อนุมัติ
                      </v-btn>
                    </v-col>
                    <v-col
                      v-if="
                        statusId === 2 &&
                          $route.params.type === 'admin' &&
                          !retireStatus
                      "
                      cols="auto"
                    >
                      <v-btn
                        class="px-12"
                        color="error"
                        depressed
                        @click="dialog = !dialog"
                      >
                        ตีกลับ
                      </v-btn>
                    </v-col>
                    <v-col
                      v-if="statusId === 3 && $route.params.type === 'admin'"
                      cols="auto"
                    >
                      <v-btn
                        class="px-12"
                        color="primary"
                        depressed
                        @click="updateDialog = !updateDialog"
                      >
                        อัพเดทข้อมูล
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        class="px-12 white--text"
                        color="grey darken-1"
                        depressed
                        @click="
                          $linkPath(
                            'HR',
                            $route.params.type === 'admin'
                              ? '/ReqCard/admin'
                              : '/ReqCard/list/' + $guid,
                            'none'
                          )
                        "
                      >
                        กลับ
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="dialog" max-width="360" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">กรอกเหตุผลในการตีกลับ</div>
        <v-divider />
        <div class="pa-4">
          <v-text-field
            v-model="reason"
            placeholder="เหตุผลในการตีกลับ"
            outlined
            dense
            required
          />
        </div>
        <div class="text-center pb-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            large
            depressed
            :disabled="reason === ''"
            @click="onReject"
          >
            บันทึก
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="dialog = !dialog"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDialog" max-width="360" persistent>
      <v-card>
        <center><div class="pa-4 font-weight-bold">ยกเลิกคำขอ</div></center>
        <div class="text-center pb-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            large
            depressed
            @click="apiCancelCard"
          >
            ตกลง
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="cancelDialog = !cancelDialog"
          >
            กลับ
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateDialog" max-width="360" persistent>
      <v-card>
        <center><div class="pa-4 font-weight-bold">อัพเดทข้อมูล</div></center>
        <v-divider />
        <div class="pa-4">
          <v-text-field
            v-model="updateForm.CardHRCode"
            label="เลขบัตร"
            outlined
            hide-details="auto"
            dense
            required
          />
        </div>
        <div class="pa-4">
          <v-menu
            v-model="StartDateDialog"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            :close-on-content-click="false"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="$dateFormatByLang(updateForm.StartDate)"
                label="วันที่ออกบัตร"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details="auto"
                dense
                v-on="on"
                @click:append="StartDateDialog = true"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="$lang === 'Tha' ? 'th' : 'en'"
              v-model="updateForm.StartDate"
              @input="StartDateDialog = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="pa-4">
          <v-menu
            v-model="ExpireDateDialog"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            :close-on-content-click="false"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="$dateFormatByLang(updateForm.ExpireDate)"
                label="วันหมดอายุ"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details="auto"
                dense
                v-on="on"
                @click:append="ExpireDateDialog = true"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="$lang === 'Tha' ? 'th' : 'en'"
              v-model="updateForm.ExpireDate"
              @input="ExpireDateDialog = false"
            ></v-date-picker>
          </v-menu>
        </div>

        <div class="text-center pb-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            depressed
            :disabled="!validate"
            @click="apiUpdateCard"
          >
            อัพเดท
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="updateDialog = !updateDialog"
          >
            กลับ
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QRious from 'qrious'

export default {
  data() {
    return {
      dialog: false,
      cancelDialog: false,
      updateDialog: false,
      StartDateDialog: false,
      ExpireDateDialog: false,
      qrcode: '',
      info: {},
      profileImg: '',
      cardDetail: {},
      reasonDetail: {},
      paymentStatus: null,
      interval: null,
      adminStatus: '',
      editAble: null,
      reason: '',
      statusId: null,
      exampleCardDetail: {},
      updateForm: {
        CardHRCode: '',
        StartDate: '',
        ExpireDate: ''
      },
      loading: false,
      filename: '',
      replyDetail: {},
      retireStatus: false
    }
  },

  computed: {
    title() {
      return 'ข้อมูลขอทำบัตร ID ' + this.$route.params.cardcode
    },
    validate() {
      return (
        this.updateForm.CardHRCode &&
        this.updateForm.StartDate &&
        this.updateForm.ExpireDate
      )
    }
  },

  created() {
    this.initialInfo().then(() => {
      if (this.paymentStatus != true && this.statusId != 5) {
        this.interval = setInterval(() => {
          if (this.$route.name === 'ReqCardRequestInfo') {
            this.checkPayment()
          } else {
            clearInterval(this.interval)
          }
        }, 5000)
      }
    })
  },

  watch: {
    '$root.$i18n.locale'() {
      this.initialInfo()
    },
    paymentStatus() {
      if (this.paymentStatus === true) {
        clearInterval(this.interval)
      }
    },
    statusId() {
      if (this.statusId === 5) {
        clearInterval(this.interval)
      }
    }
  },

  methods: {
    onEdit() {
      if (this.retireStatus) {
        this.$router.push({
          path: '/ReqCard/oldemp/edit',
          query: {
            cardcode: this.$route.params.cardcode
          }
        })
      } else {
        this.$router.push({
          path: '/ReqCard/add/' + this.$guid,
          query: {
            isEdit: true,
            cardcode: this.$route.params.cardcode
          }
        })
      }
    },
    async checkPayment() {
      this.paymentStatus = await this.apiCheckPayment()
    },
    async onApprove() {
      let body = {
        ReqCardStatusId: 3,
        ReqCardCode: this.$route.params.cardcode,
        Reason: ''
      }

      await this.apiPutCardStatus(body)
      this.initialInfo()
    },
    async onReject() {
      let body = {
        ReqCardStatusId: 4,
        ReqCardCode: this.$route.params.cardcode,
        ReplyDetail: this.reason
      }
      this.reason = ''
      this.dialog = false
      await this.apiPutCardStatus(body)
      this.initialInfo()
    },

    async initialInfo() {
      const info = await this.apiGetInfo()
      const lang = this.$lang
      const qrcode = new QRious({
        value: info.qrCode,
        size: 300
      })
      this.qrcode = qrcode.toDataURL()
      this.filename = info[`firstName${lang}`] + ' ' + info[`lastName${lang}`]
      this.info = [
        {
          id: 'firstName',
          title: 'ชื่อ',
          value: info[`firstName${lang}`]
            ? info[`firstName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-file-document-multiple'
        },
        {
          id: 'lastName',
          title: 'นามสกุล',
          value: info[`lastName${lang}`]
            ? info[`lastName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-file-document-multiple'
        },
        {
          id: 'birthDate',
          title: 'วันเกิด',
          value:
            lang === 'Tha'
              ? this.$dateFormatByLang(info.birthDate, {
                  format: 'DD MMMM YYYY',
                  addValue: 543
                })
              : this.$dateFormat(info.birthDate, {
                  format: 'DD MMMM YYYY',
                  locale: 'en'
                }),
          icon: 'mdi-cake'
        },
        {
          id: 'personalId',
          title: 'เลขบัตรประจำตัวประชาชน',
          value: info[`personalId`] ? info[`personalId`] : this.$t('noData'),
          icon: 'mdi-card-account-details',
          limit: 13
        },
        {
          id: 'cardEmpTypeFullName',
          title: 'ประเภทบุคลากร',
          value: info[`cardEmpTypeFullName${lang}`]
            ? info[`cardEmpTypeFullName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-account-outline'
        },
        {
          id: 'positionName',
          title: 'ตำแหน่ง',
          value: info[`positionName${lang}`]
            ? info[`positionName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-account-circle'
        },
        {
          id: 'emailCmu',
          title: 'อีเมล',
          value: info[`emailCmu`] ? info[`emailCmu`] : this.$t('noData'),
          icon: 'mdi-at'
        },
        {
          id: 'bloodType',
          title: 'กรุ๊ปเลือด',
          value: info[`bloodType`] ? info[`bloodType`] : this.$t('noData'),
          icon: 'mdi-water'
        },
        {
          id: 'addresss',
          title: 'ที่อยู่',
          value: info[`addresss`] ? info[`addresss`] : this.$t('noData'),
          icon: 'mdi-map-marker'
        },
        {
          id: 'mobilePhone',
          title: 'หมายเลขโทรศัพท์',
          value: info[`mobilePhone`] ? info[`mobilePhone`] : this.$t('noData'),
          icon: 'mdi-phone',
          edit: true,
          limit: 10
        }
      ]

      if (info[`middleName${lang}`]) {
        this.info.splice(1, 0, {
          id: 'middleName',
          title: 'ชื่อกลาง',
          value: info[`middleName${lang}`]
            ? info[`middleName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-file-document-multiple'
        })
      }

      this.profileImg = info.reqCardImg
      this.cardDetail = [
        {
          id: 'cardTypeFullName',
          title: 'ประเภทบัตร',
          value: info[`cardTypeFullName${lang}`]
            ? info[`cardTypeFullName${lang}`]
            : this.$t('noData'),
          icon: 'mdi-account-tie'
        }
      ]
      if (info['reqCardStatusId'] === 3) {
        this.updateForm.StartDate = info.startDate
          ? info.startDate.substr(0, 10)
          : ''
        this.updateForm.ExpireDate = info.expireDate
          ? info.expireDate.substr(0, 10)
          : ''
        this.updateForm.CardHRCode = info.cardHRCode
        this.cardDetail.push({
          id: 'CardHRCode',
          title: 'เลขบัตร',
          value: info.cardHRCode ? info.cardHRCode : this.$t('noData'),
          icon: 'mdi-card-account-details'
        })
        this.cardDetail.push({
          id: 'StartDate ',
          title: 'วันที่ออกบัตร',
          value: info.startDate
            ? this.$dateFormatByLang(info.startDate)
            : this.$t('noData'),
          icon: 'mdi-clock-outline'
        })
        this.cardDetail.push({
          id: 'ExpireDate ',
          title: 'วันหมดอายุ',
          value: info.expireDate
            ? this.$dateFormatByLang(info.expireDate)
            : this.$t('noData'),
          icon: 'mdi-clock'
        })
      }
      this.reasonDetail = [
        {
          id: 'reasonReqCard',
          title: 'เหตุผลในการขอทำบัตร',
          value: info[`reasonReqCard`]
            ? info[`reasonReqCard`]
            : this.$t('noData'),
          icon: 'mdi-atom-variant'
        }
      ]

      this.replyDetail = info.replyDetail

      info.reqCardDocuments.forEach((item, index) => {
        let counter = this.$zeroPrefix(index + 1)
        this.reasonDetail.push({
          id: 'reasonFile' + counter,
          title: 'เอกสารประกอบ ฉบับที่ ' + counter,
          value: '<a>Download</a>',
          icon: 'mdi-attachment',
          docName: item.reqCardDocName
        })
      })

      this.receipt = [
        {
          id: 'receipt',
          title: 'ใบเสร็จชำระเงิน',
          value: '<a>Download</a>',
          icon: 'mdi-receipt',
          docName: info.receiptFileName
        }
      ]
      this.paymentStatus = info['paymentStatus']
      this.adminStatus = info['adminStatus'].accessRoleName
      this.editAble = info['reqEditAble']
      this.statusId = info['reqCardStatusId']
      this.retireStatus = info['retireStatus']

      this.exampleCardDetail = [
        {
          id: 'cardCode',
          title: 'รหัสคำขอ',
          value: this.$route.params.cardcode
            ? this.$route.params.cardcode
            : this.$t('noData'),
          style: 'font-size: 16px;'
        },
        {
          id: 'cardType',
          title: 'ประเภท',
          value: info[`cardTypeFullName${lang}`]
            ? info[`cardTypeFullName${lang}`]
            : this.$t('noData'),
          style: 'font-size: 12px;'
        },
        {
          id: 'name',
          title: 'ชื่อ',
          value:
            !!info[`firstName${lang}`] && !!info[`lastName${lang}`]
              ? info[`firstName${lang}`] +
                ' ' +
                info[`middleName${lang}`] +
                ' ' +
                info[`lastName${lang}`]
              : this.$t('noData'),
          style: 'font-size: 12px;'
        },

        {
          id: 'createdDate',
          title: 'วันที่ขอ',
          value: info.createDate
            ? this.$dateFormatByLang(info.createDate, {
                format: 'DD/MM/YY - HH:mm',
                addValue: '543'
              })
            : this.$t('noData'),
          icon: 'mdi-account-outline',
          style: 'font-size: 12px;'
        }
      ]
    },

    onDownloadProfileImage() {
      // console.log(this.profileImg)
      var arr = this.profileImg.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var type = mime.split('/')[1]

      var fileLink = document.createElement('a')
      fileLink.href = this.profileImg
      fileLink.download = this.filename + '.' + type
      // document.body.appendChild(fileLink)
      fileLink.click()
    },

    async apiGetFile(docName) {
      try {
        const res = await this.$store.dispatch('reqCard/getFile', docName)
        // console.log(res.data)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.download = docName
        // document.body.appendChild(fileLink)

        fileLink.click()
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetReceipt(docName) {
      try {
        const res = await this.$store.dispatch('reqCard/getReceipt', docName)
        // console.log(res.data)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.download = docName
        // document.body.appendChild(fileLink)

        fileLink.click()
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetInfo() {
      this.loading = true
      try {
        const res = await this.$store.dispatch(
          'reqCard/getInfoByCardcode',
          this.$route.params.cardcode
        )
        this.loading = false
        // console.log(res.data?.data)
        return res.data?.data
      } catch (e) {
        this.loading = false
        console.log(e.response || e)
      }
    },

    async apiCheckPayment() {
      try {
        const res = await this.$store.dispatch(
          'reqCard/getStatusByCardcode',
          this.$route.params.cardcode
        )
        // console.log(res.data?.data.paymentStatus)
        return res.data?.data.paymentStatus
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiUpdateCard() {
      try {
        const res = await this.$store.dispatch('reqCard/updateCard', {
          ReqCardCode: this.$route.params.cardcode,
          CardHRCode: this.updateForm.CardHRCode,
          StartDate: this.updateForm.StartDate,
          ExpireDate: this.updateForm.ExpireDate
        })
        this.updateDialog = false
        this.initialInfo()
        // console.log(res)
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiPutCardStatus(body) {
      try {
        const res = await this.$store.dispatch('reqCard/setReqCardStatus', body)
        // console.log(res)
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiCancelCard() {
      try {
        const res = await this.$store.dispatch('reqCard/deleteReqCard', {
          ReqCardCode: this.$route.params.cardcode
        })
        if (this.retireStatus) {
          this.$router.push('/ReqCard/admin')
        } else {
          this.$router.push('/ReqCard/list/' + this.$guid)
        }

        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
